export const stylesGenericInputErrorCP = {
  wrapper: {
    fontSize: "12px",
    color: "#af272f",
    fontFamily: "RobotoRegular",
  },
  paragraph: {},
};

export const stylesGenericInputErrorTelcel = {};
